import React from 'react';
import { CountryFlagImage, CountryFlagSVG } from '../Dropdown/styled';
export var filterOptionList = function filterOptionList(localizedCountryList, value, countryCode) {
  // check if country is already selected, then show all options
  if (countryCode) {
    return localizedCountryList;
  }
  return localizedCountryList.filter(function (country) {
    return country.toLowerCase().startsWith(value.toLowerCase());
  });
};
export var addressStateSelector = function addressStateSelector(state) {
  return {
    userAddressState: state.userAddress,
    flagUrl: state.config.appConstants.flagUrl
  };
};
export var getFlagIcon = function getFlagIcon(_ref) {
  var icon = _ref.icon,
    value = _ref.value,
    inputValue = _ref.inputValue,
    flagUrl = _ref.flagUrl;
  return icon ? /*#__PURE__*/React.createElement(CountryFlagSVG, {
    "aria-label": "".concat(value ? value : inputValue, " Flag")
  }, /*#__PURE__*/React.createElement(CountryFlagImage, {
    href: "".concat(flagUrl).concat(icon.toLocaleLowerCase(), ".svg")
  })) : undefined;
};
export var getSanitizedInput = function getSanitizedInput(input) {
  return input.trim();
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/internal/AutocompleteWrapper/helpers.js
// module id = 4512
// module chunks = 11